<div class="new_login_modal registerForm">
    <div class="row m-0">
        <div class="col-md-6 col-12 px-0">
           
            <div class="login_form login_fileds text-center" *ngIf="show">
                <div class="img_logo">
                    <img src="https://media.iquanta.in/ui_images/iquanta-logo-white.png" alt="">
                </div>
                <h5>Welcome to iQuanta</h5>

                <div class="text">
                    <!-- <p>Enter a Phone number. We Will send you a one time SMS message. Carrier rates may apply.</p> -->

                    <form class="tab_section" [ngClass]="{'otpCard': otpFlag}" [formGroup]="otpForm">
                        <h1 *ngIf="otpFlag">OTP Verification</h1>

                        <div class="desk-none">
                            <div class="row d-flex justify-content-center">

                                <div *ngIf="!otpFlag" class="col-md-12">
                                    <div class="form-group">
                                        <input formControlName="phone_no" (keypress)="isNumber($event)"
                                            placeholder="Login with Phone Number" type="text"
                                            class="form-control f-light">
                                        <p class="error-msg" *ngIf="!otpFlag && errorMsg">{{errorMsg}}</p>
                                    </div>
                                 
                                </div>


                                <div *ngIf="otpFlag" class="col-md-12">
                                    <div class="form-group">
                                        <input formControlName="otp" placeholder="OTP" (keypress)="isNumber($event)"
                                            autocomplete="off" type="text" class="form-control f-light">
                                        <p class="error-msg" *ngIf="errorMsg">{{errorMsg | titlecase}}</p>
                                    </div>
                                </div>

                                <div class="col-md-12 text-center">
                                    <button  class="savebtn" *ngIf="!otpFlag"
                                        (click)="loginotponsubmit()">Next</button>
                                    <button  class="savebtn" *ngIf="otpFlag" (click)="verifyOtp()">Verify
                                        Otp</button>

                                </div>
                            </div>
                        </div>

                        <div class="mobile-none">
                            <div class="row justify-content-center">

                                <div *ngIf="!otpFlag" class="col-md-12">
                                    <div class="form-group">
                                        <input formControlName="phone_no" (keypress)="isNumber($event)"
                                            placeholder="Login with Phone Number" type="text"
                                            class="form-control f-light" autocomplete="off">
                                        <p class="error-msg mt-1" *ngIf="!otpFlag && errorMsg">{{errorMsg}}</p>
                                    </div>
                                </div>


                                <div *ngIf="otpFlag" class="col-md-12">
                                    <div class="form-group">
                                        <input formControlName="otp" placeholder="OTP" (keypress)="isNumber($event)"
                                            autocomplete="off" type="text" class="form-control f-light">
                                        <p class="error-msg" *ngIf="errorMsg">{{errorMsg | titlecase}}</p>
                                    </div>
                                  
                                </div>

                                <div class="col-md-12 text-center">
                                    <button  class="savebtn" *ngIf="!otpFlag"
                                        (click)="loginotponsubmit()">Send Code</button>
                                    <button  class="savebtn" *ngIf="otpFlag" (click)="verifyOtp()">Verify
                                        Otp</button>
                                </div>




                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div *ngIf="otpFlag" class="resend col-md-12">
                                    <p>Didn’t receive code? <span (click)="loginotponsubmit()">Request again</span> </p>
                                </div>

                                <ng-container *ngIf="!otpFlag">
                                    <div class="separator col-md-12 ">
                                        <p>Or</p>
                                    </div>

                                    <div class="other-btns col-md-12 p-0">
                                        <button id="loginRef"  class="bg_color" (click)="googleSDK()">

                                            <img src="https://media.iquanta.in/ui_images/icons/google.png" alt="">
                                            <span>
                                                Login with Google
                                            </span>

                                        </button>
                                        <button class="mt-2"
                                            (click)="gotolink('http://wa.me/917836814598')">
                                            <div class="phone_icon d-flex">
                                                <img src="https://media.iquanta.in/ui_images/trouble.png">
                                                <span>Having trouble?</span>
                                            </div>
                                        </button>

                                    </div>
                                </ng-container>

                            </div>
                        </div>

                    </form>

                </div>
                <div class="footer">
                    <p>Follow us at</p>
                    <div class="social_media d-flex">
                        <img (click)="gotolink('https://www.facebook.com/iQuanta.in')"
                            src="https://media.iquanta.in/ui_images/icons/facebook.png" alt="">
                        <img (click)="gotolink('https://www.instagram.com/iQuanta.in/')"
                            src="https://media.iquanta.in/ui_images/icons/insta.png" alt="">
                        <img (click)="gotolink('https://www.youtube.com/@CatpreparationiQuanta')"
                            src="https://media.iquanta.in/ui_images/icons/youtube.png" alt="">
                    </div>
                </div>
            </div>

            <div class="login_form login_fileds tab_section p-3" *ngIf="newUserFlag">
                <div class="text1 d-flex justify-content-between">
                    <h5><span (click)="show = true; newUserFlag = false; otpFlag = false;"><i
                                class="bi bi-arrow-left"></i></span>Create Account</h5>
                    <p>1 of 3</p>
                </div>

                <p class="error-msg">{{singupError}}</p>
                <div class="reg_form">
                    <form [formGroup]="registerForm">
                        <div class="row m-0 p-0">

                            <div class="col-md-6 desk-none">
                                <div class="profile ">
                                    <img width="75px" height="75px"
                                        [src]="structureFile ? structureFile : 'https://media.iquanta.in/ui_images/new-dashboard/userpic.png'"
                                        alt="">
                                    <button  class="edite_btn fileContainer file-upload-button">
                                        <input type="file" class="upload-file" placeholder="Edit"
                                            (change)="onFileChanged($event)" />
                                        <span>Edit</span>
                                    </button>

                                </div>
                            </div>
                            <div class="col-md-6 p-0">
                                <div class="form-group">
                                    <input placeholder="Name" formControlName="first_name" type="text"
                                        class="form-control f-light" autocomplete="off">
                                </div>
                            </div>
                            <div class="col-md-6 mobile-none">
                                <div class="profile ">
                                    <img width="75px" height="75px"
                                        [src]="structureFile ? structureFile : 'https://media.iquanta.in/ui_images/new-dashboard/userpic.png'"
                                        alt="">
                                    <button  class="edite_btn fileContainer file-upload-button">
                                        <input type="file" class="upload-file" placeholder="Edit"
                                            (change)="onFileChanged($event)" />
                                        <span>Edit</span>
                                    </button>

                                </div>
                            </div>
                        </div>
                        <div class="row m-0 p-0">
                            <div class="col-md-12 p-0">
                                <div class="form-group">
                                    <input placeholder="Enter EmailId" formControlName="email" type="text"
                                        class="form-control f-light" autocomplete="off">
                                </div>
                            </div>

                        </div>
                        <div class="row m-0 p-0">
                            <div class="col-md-12 p-0">
                                <div class="form-group">
                                    <input placeholder="Enter Phone Number" minlength="10" maxlength="10"
                                        formControlName="phone_no" type="text" class="form-control f-light"
                                        autocomplete="off">
                                </div>
                            </div>

                        </div>
                        <div class="row m-0 p-0">
                            <div class="col-md-12 p-0">
                                <div class="form-group">
                                      <!-- <select  aria-label="City" data-live-search="true" formControlName="city" class="form-control selectpicker"
                                            id="exampleFormControlSelect2">
                                            <option *ngFor="let city of cityList" [value]="city"> {{city}}</option>
                                        </select> -->
                                    <mat-form-field  class="w-100 m-t-5">
                                        <input type="text" matInput formControlName="city" placeholder="City"
                                            [matAutocomplete]="auto" (keyup)="filter($event)">
                                        <mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let city of cityList" [value]="city">
                                                {{city}}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <!-- <select formControlName="city" placeholder="City" class="form-control f-light">
                                    <option value="" [hidden]="">Current City</option>
                                    <option *ngFor="let city of cityList" [value]="city"> {{city}}</option>
                                </select> -->
                                </div>
                            </div>
                        </div>
                        <div class="row m-0 p-0 justify-content-between">
                            <div class="col-md-4 p-0">
                                <div class="form-group">
                                    <select formControlName="gender" placeholder="Gender" class="form-control f-light">
                                        <option value="" [hidden]="">Gender</option>
                                        <option value="Male"> Male</option>
                                        <option value="Female"> Female</option>
                                        <option value="Other"> Other</option>
                                    </select>
                                </div>

                            </div>
                            <div class="col-md-7 p-0 date_pick">
                                <div class="form-group">
                                    <input placeholder="Date of Birth" minlength="10" maxlength="10"
                                        formControlName="dob" type="date" class="form-control f-light"
                                        autocomplete="off">
                                </div>

                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-12">

                                <div class="progress_bar">
                                    <ul>
                                        <li class="line_1">
                                            <div class="dot"></div>
                                        </li>
                                        <li class="line_2">
                                            <div class="dot-outline"></div>
                                        </li>
                                        <li class="line_3">
                                            <div class="dot-outline"></div>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div> -->
                        <div class="row m-0 p-0">
                            <div class="col-md-12 px-0">
                                <button class="savebtn"  (click)="nextStep()">
                                    Next
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="login_form login_fileds p-3" *ngIf="show3">
                <div class="text1 d-flex justify-content-between">
                    <h5><span (click)="show3 = false; newUserFlag = true"><i class="bi bi-arrow-left"></i></span>Select
                        the category of exam</h5>
                    <p>2 of 3</p>
                </div>

                <div class="row m-0 p-0">
                    <div class="col-md-6 col-6 px-0" *ngFor="let cat of categoryExams">
                        <div class="cards" (click)="selectCat(cat)"
                            [ngClass]="{'selected': selectedCategory?.value == cat.value}">
                            <div class="card" class="bg_1 {{'bg_'+ cat.id}} middle p-1">
                                <h1>{{cat.category}}</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row m-0 p-0 mt-4">
                    <div class="col-md-12 px-0">
                        <button class="savebtn"  (click)="nextStep2()">
                            Next
                        </button>
                    </div>
                </div>
            </div>

            <div class="login_form login_fileds p-3" *ngIf="show4">
                <div class="text1 d-flex justify-content-between">
                    <h5><span (click)="show4 = false; show3 = true"><i class="bi bi-arrow-left"></i></span>Select the
                        category of exam</h5>
                    <p>3 of 3</p>
                </div>

                <div class="row m-0 p-0 justify-content-center">
                    <div class="col-md-12" *ngIf="singupError">
                        <p class="error-msg">{{singupError}}</p>
                    </div>
                    <div class="col-md-6 col-6 px-0" *ngFor="let exam of selectedCategory?.exams">
                        <div class="exam_prepration">
                            <mat-checkbox (click)="selectSubCat(exam)" [value]="exam"
                                class="example-margin">{{exam}}</mat-checkbox>
                        </div>
                    </div>

                    <div class="col-md-12 px-0 mt-4">
                        <button class="savebtn"  (click)="register()">
                            Sign up
                        </button>
                    </div>
                </div>
            </div>


        </div>

        <div class="col-md-6 col-12 px-0">
            <div class="img" *ngIf="imageObj">
                <div class="img-div" [ngStyle]="{'background':'url('+imageObj?.login_image_url+')'}"
                    (click)="gotolink1()">
                </div>
            </div>
        </div>

    </div>

</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white;text-align: center;font-size:30px"> <b>Loading...</b> </p>

</ngx-spinner>